export const typography = {
  fontFamily: '"Roboto", "Arial", sans-serif',
  h1: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  h2: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  h3: {
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h4: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.6,
  },
  h5: {
    fontSize: '.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  h6: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body3: {
    fontSize: '0.75rem',
    fontWeight: 400,
    textTransform: 'none',
  },
};
